(ns frontend.view.grid.lp-reports-grid.view
  (:require
   [basic-components.html-table.table :as table]
   [common.localization :as loc]
   [frontend.logging :as logging]
   [frontend.page-components.zap-toolbar :as zap-toolbar]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [frontend.view.components.spinner :as spinner]
   [frontend.view.grid.lp-reports-grid.event :as event]
   [frontend.view.grid.lp-reports-grid.sub :as sub]
   [frontend.page-components.default-page-layout :as default-page-layout]
   [re-frame.core :as rf]
   [reagent.core :as r]))

(defn unload-handler
  [v _a]
  (when (not= [:lp-reports-grid] v)
    (rf/dispatch [::event/unload])))

(defn title-cell-renderer
  [{:keys [cell-value row-data]}]
  [:a
   {:href "#"
    :on-click #(rf/dispatch [::event/open-report row-data])}
   cell-value])

(defn user-highlight-style
  [{:keys [cell-value _row-data]}]
  (when (some #{@session/account-id}
              (if (coll? cell-value)
                cell-value
                [cell-value]))
    {:background-color "#8ABF4C"}))

(def columns
  [{:column/key       :row-id
    :column/label     (loc/tr :row-id)
    :column/data-type :data.type/text-simple
    :column/sortable? true}

   {:column/key           :fund/name
    :column/label         (loc/tr :fund-name)
    :column/data-type     :data.type/text-simple
    :column/cell-renderer title-cell-renderer
    :column/sortable?     true}

   {:column/key       :common/created-on
    :column/label     (loc/tr :created-on)
    :column/data-type :data.type/datetime
    :column/sortable? true}

   {:column/key       :lp-report/step
    :column/label     (loc/tr :lp-report-step)
    :column/data-type :data.type/keyword
    :column/sortable? true}

   {:column/key       :lp-report/template-type
    :column/label     (loc/tr :fund-template-type)
    :column/data-type :data.type/keyword
    :column/sortable? true}

   {:column/key       :lp-report-holding/template-type
    :column/label     (loc/tr :holding-template-type)
    :column/data-type :data.type/keyword
    :column/sortable? true}

   {:column/key           :lp-report/title
    :column/cell-renderer title-cell-renderer
    :column/label         (loc/tr :lp-report/title)
    :column/data-type     :data.type/text-simple
    :column/sortable?     true}

   {:column/key       :lp-report/text-status
    :column/label     (loc/tr :lp-report-fund-text-status)
    :column/data-type :data.type/keyword
    :column/sortable? true}

   {:column/key           :lp-report/text-contributors
    :column/label         (loc/tr :lp-report-fund-text-contributors)
    :column/cell-style-fn user-highlight-style
    :column/data-type     :data.type/ref-multi
    :column/sortable?     true}

   {:column/key           :lp-report/text-approver
    :column/label         (loc/tr :lp-report-fund-text-approver)
    :column/cell-style-fn user-highlight-style
    :column/data-type     :data.type/ref-single
    :column/sortable?     true}

   {:column/key       :lp-report/data-status
    :column/label     (loc/tr :lp-report-fund-data-status)
    :column/data-type :data.type/keyword
    :column/sortable? true}

   {:column/key           :lp-report/data-contributors
    :column/label         (loc/tr :lp-report-fund-data-contributors)
    :column/cell-style-fn user-highlight-style
    :column/data-type     :data.type/ref-multi
    :column/sortable?     true}

   {:column/key           :lp-report/data-approver
    :column/label         (loc/tr :lp-report-fund-data-approver)
    :column/cell-style-fn user-highlight-style
    :column/data-type     :data.type/ref-single
    :column/sortable?     true}

   {:column/key           :lp-report/process-owners
    :column/label         (loc/tr :lp-report-process-owners)
    :column/cell-style-fn user-highlight-style
    :column/data-type     :data.type/ref-multi
    :column/sortable?     true}

   {:column/key           :lp-report/final-approver
    :column/label         (loc/tr :lp-report-final-approver)
    :column/cell-style-fn user-highlight-style
    :column/data-type     :data.type/ref-single
    :column/sortable?     true}

   {:column/key       :lp-report-separator
    :column/label     "*********"
    :column/data-type :data.type/text-simple}

   {:column/key       :lp-report-holding/name
    :column/label     (loc/tr :holding-name)
    :column/data-type :data.type/text-simple
    :column/sortable? true}

   {:column/key       :lp-report-holding/text-status
    :column/label     (loc/tr :lp-report-holding-text-status)
    :column/data-type :data.type/keyword
    :column/sortable? true}

   {:column/key           :lp-report-holding/text-contributors
    :column/label         (loc/tr :lp-report-holding-text-contributors)
    :column/cell-style-fn user-highlight-style
    :column/data-type     :data.type/ref-multi
    :column/sortable?     true}

   {:column/key           :lp-report-holding/text-approver
    :column/label         (loc/tr :lp-report-holding-text-approver)
    :column/cell-style-fn user-highlight-style
    :column/data-type     :data.type/ref-single
    :column/sortable?     true}

   {:column/key       :lp-report-holding/data-status
    :column/label     (loc/tr :lp-report-holding-data-status)
    :column/data-type :data.type/keyword
    :column/sortable? true}

   {:column/key           :lp-report-holding/data-contributors
    :column/label         (loc/tr :lp-report-holding-data-contributors)
    :column/cell-style-fn user-highlight-style
    :column/data-type     :data.type/ref-multi
    :column/sortable?     true}

   {:column/key           :lp-report-holding/data-approver
    :column/label         (loc/tr :lp-report-holding-data-approver)
    :column/cell-style-fn user-highlight-style
    :column/data-type     :data.type/ref-single
    :column/sortable?     true}])

(defn toolbar
  [columns]
  [:div
   {:class "px-4 py-1 flex items-center justify-between bg-base-light
            border-b border-solid border-base-light-border-paler"}
   [:div
    {:class "w-full flex justify-between gap-6"}
    [:div
     [:div
      {:class "flex gap-2 items-center"}]]
    [:div
     {:class "flex justify-content-end items-center gap-2"}
     [:div
      (zap-toolbar/dropdown [{:toolbar-button? true
                              :dropdown-action? true
                              :ord 1
                              :primary-button? false
                              :add-ellipsis? true
                              :on-select #(rf/dispatch [::event/open-columns-selector columns])
                              :label (loc/tr :action/select-columns)}]
                            true)]]]])
(defn view
  []
  (let [table-state (r/atom {})]
    (r/create-class
     {:component-did-mount
      (fn [_]
        (routing/add-change-interceptor ::mount unload-handler))
      :component-will-unmount
      (fn [_]
        (routing/remove-change-interceptor ::mount))
      :reagent-render
      (fn []
        (let [loading? @(rf/subscribe [::sub/loading?])
              reports @(rf/subscribe [::sub/reports])
              visible-colums @(rf/subscribe [::sub/report-columns (:db/id @session/account)
                                             (map :db/id @session/account-teams)])
              selected-columns @(rf/subscribe [::sub/selected-columns])]
          (cond
            loading?
            [:div
             {:class-name "mt-4 px-4"}
             [spinner/loading]]
            (zero? (count reports))
            [:div
             {:class-name "mt-4 px-4"}
             (loc/tr :lp-reporting-grid-no-rows)]
            :else
            [:div
             {:class-name "mt-4 px-4"}
             [toolbar columns]
             [:div.scrollable-content
              [table/view
               reports
               {:id-key    :row-id
                :table-key "test-table"
                :columns   (->> columns
                                (filter (fn [c]
                                          (some #{(:column/key c)} visible-colums)))
                                (filter (fn [c]
                                          (some #{(:column/key c)} selected-columns))))
                :state     table-state
                :settings  {:show-selection?        true
                            :show-filters?          true
                            :show-grouping?         true
                            :show-sorting?          true
                            :default-sort-key       :lp-report/step
                            :column-order           nil
                            :sticky-column-group    0
                            :filters                []
                            :on-selection-change-fn (fn [selected-ids]
                                                      (logging/info "table selection "
                                                                    selected-ids))
                            :on-settings-change     (fn [table-settings]
                                                      (logging/info "New table settings "
                                                                    table-settings))}}]]])))})))

(defmethod routing/render-view :lp-reports-grid
  []
  (rf/dispatch [::event/set-visible-columns nil])
  (rf/dispatch [::event/reload columns])
  (let [_view-mode :grid-mode]
    [default-page-layout/view
     [view]]))
